import { useContext } from 'react';
import { AuthContext } from 'contexts/AwsCognitoContext';

const useAuth = () => useContext(AuthContext);

export default useAuth;
